// src/store/slices/categoriesSlice.ts
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { triviaApi } from '../../services/api';

// 類別類型
export interface Category {
  id: string;
  name: string;
  description?: string;
  slug?: string;
}

interface CategoriesState {
  categories: Category[];
  loading: boolean;
  error: string | null;
}

const initialState: CategoriesState = {
  categories: [],
  loading: false,
  error: null,
};

// 獲取所有類別
export const fetchAllCategories = createAsyncThunk(
  'categories/fetchAll',
  async (_, { rejectWithValue }) => {
    try {
      // 假設 API 有獲取所有類別的方法
      const categories = await triviaApi.getAllCategories();
      return categories;
    } catch (error) {
      return rejectWithValue('無法獲取類別列表');
    }
  }
);

const categoriesSlice = createSlice({
  name: 'categories',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllCategories.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllCategories.fulfilled, (state, action) => {
        state.loading = false;
        state.categories = action.payload;
      })
      .addCase(fetchAllCategories.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export default categoriesSlice.reducer;
